import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import authSlice from "@slices/auth.slice";

import OrganisationList from "../OrganisationListPage/OrganisationListPage";

const DashboardPageComponent = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { userEmail, verificationCode } = params;

  useEffect(() => {
    if (userEmail && verificationCode) {
      dispatch(
        authSlice.actions.passParams({
          userEmail: userEmail,
          verificationCode: verificationCode,
        })
      );
    }
  }, [dispatch, userEmail, verificationCode]);

  return <OrganisationList />;
};

const DashboardPage = withTranslation()(DashboardPageComponent);

export default DashboardPage;
